import { AppointmentProductPaymentDetails } from '@/shared/appointments/appointment-product-payment-details';
import { InstructionType } from '@/shared/instruction-type';

export interface AppointmentOutcomeProduct {
    productTypeId: string;
    instructionType: InstructionType;
    instructedDate: string | Date | null;
    instructedValue: number | null;
    albReference: string | null;
    paymentDetails: Array<AppointmentProductPaymentDetails>;
    paymentStatusId?: string | null;
    version?: number;
}

export function createAppointmentOutcomeProduct(productTypeId: string): AppointmentOutcomeProduct {
    return {
        productTypeId,
        instructionType: InstructionType.NotInstructed,
        instructedDate: null,
        instructedValue: null,
        albReference: null,
        paymentDetails: new Array<AppointmentProductPaymentDetails>(),
    };
}
